module.exports = __webpack_public_path__ + "img/iphone.4d288fba.png";